import { createContext } from "react";

export const ContextUser = createContext<any>(null);